import navMenu from './navMenu.vue'
export default navMenu